import { writable, get } from 'svelte/store';
import * as util from '../js/util.js';

function createMyStore() {
    const { subscribe, set, update } = writable(
        {
            countries: [],
            currentCountry: { country: { nameKey: null, countryVersion: [] }, languages: [] },
            currentCountryVersion: {},
            langs: []
        }
    );
    return {
        subscribe, get,

        getCountryVersions: async () => {
            return await util.fetchJson('api/Country/getallcountryversions');
        },
        getCountries: async () => {
            const json = await util.fetchJson('api/Country/getallcountries');
            update(n => { return Object.assign(n, { countries: json }) });
            const langs = await util.fetchJson('api/Lang/getlangs');
            update(n => { return Object.assign(n, { langs: langs }) });
        },
        saveCountry: async (theCountry) => {
            var ret = await util.fetchJsonWithMethod('PUT', 'api/Country/save', theCountry);
            await countryStore.getCountries();
            return ret;
        },
        saveCountryVersion: async (theCountryVersion) => {
            var ret = await util.fetchJsonWithMethod('PUT', 'api/Country/savecountryversion', theCountryVersion);
            return ret;
        },
        deleteSection: async (sectionId) => {
            var ret = await util.fetchJsonWithMethod('POST', 'api/Country/deleteSection', { id: sectionId });
            return ret;
        },
        saveSectionSub: async (sectionSub) => {
            var ret = await util.fetchJsonWithMethod('PUT', 'api/Country/savesectionsub', sectionSub);
            return ret;
        },
        saveCountryVersionVar: async (theCountryVersionVar) => {
            var ret = await util.fetchJsonWithMethod('PUT', 'api/Country/savecountryversionvar', theCountryVersionVar);
            return ret;
        },
        copyCountryVersion: async (theCountryVersionId) => {
            var ret = await util.fetchJsonWithMethod('POST', 'api/Country/copycountryversion', theCountryVersionId);
            return ret;
        },
        importCountryVersion: async (theFile, theCountryId) => {
            let formData = new FormData();
            formData.append("countryId", theCountryId);
            formData.append("thefile", theFile);
            var result = await fetch('/api/country/importcountryversion', { method: "POST", body: formData });
            return await result.json();
        },
        deleteCountryVersion: async (theCountryVersion) => {
            var ret = await util.fetchJsonWithMethod('POST', 'api/Country/deletecountryversion', theCountryVersion);
            return ret;
        },
        deleteCountry: async (theCountry) => {
            var ret = await util.fetchJsonWithMethod('POST', 'api/Country/deletecountry', theCountry);
            return ret;
        },
        getCountry: async (countryId) => {
            const json = await util.fetchJson('api/Country/getCountry?countryid=' + countryId);
            update(n => { return Object.assign(n, { currentCountry: json }) });
        }
        ,
        getCurrencies: async () => {
            const json = await util.fetchJson('api/Country/getallcurrencies');
            return json;

        },
        getCountryVersion: async (countryVersionId) => {
            var json = await util.fetchJson('api/Country/getCountryVersion?countryversionid=' + countryVersionId);
            update(n => { return Object.assign(n, { currentCountryVersion: json }) });
            json = await util.fetchJson('api/Country/getCountry?=false&countryid=' + json.countryId);
            update(n => { return Object.assign(n, { currentCountry: json }) });
            return json;
        },
        deleteVariables: async (countryId) => {
            var ret = await util.fetchJsonWithMethod('POST', 'api/Country/deletecountryvars', { id: parseInt(countryId) });
        },

        importExcel: async (thefile, countryVersionId) => {
            let formData = new FormData();
            formData.append("countryVersionId", countryVersionId);
            formData.append("thefile", thefile);
            var result = await fetch('/api/country/importexcelforcountryversion', { method: "POST", body: formData });
            return await result.json();
        }

    };
}
export const countryStore = createMyStore();